import { ContactForm } from "../components/ContactForm";
import SEO from "@/components/SEO";

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Motosport Software | Dealer Workflow Platform"
        description="Contact Motosport Software to learn how our platform connects buyer intent, dealer inventory, and transaction workflows."
        url="https://motosportsoftware.com/contact"
      />
      <main className="px-4 py-12 sm:px-6">
        <ContactForm />
      </main>
    </>
  );
}
